import React from 'react';
import "./styles.pcss";
export var AccountsMapper = function AccountsMapper(_ref) {
  var accounts = _ref.accounts,
    children = _ref.children;
  if (!accounts) {
    return null;
  }
  return /*#__PURE__*/React.createElement("ul", {
    "data-t-id": "components-AccountsMapper"
  }, accounts === null || accounts === void 0 ? void 0 : accounts.map(function (account) {
    return /*#__PURE__*/React.createElement("li", {
      key: (account === null || account === void 0 ? void 0 : account.login) || (account === null || account === void 0 ? void 0 : account.formattedAccountNumber)
    }, children(account));
  }));
};